// import React, { useEffect, useState } from 'react';

// const Counter = ({ start, end, duration }) => {
//   const [count, setCount] = useState(start);

//   useEffect(() => {
//     // Calculate the interval based on the duration
//     const increment = (end - start) / (duration / 50); // Increment by a fraction
//     let currentCount = start;
//     const interval = setInterval(() => {
//       currentCount += increment;
//       if (currentCount >= end) {
//         setCount(end);
//         clearInterval(interval); // Stop the interval when the end is reached
//       } else {
//         setCount(Math.floor(currentCount)); // Set the updated count
//       }
//     }, 50); // Update every 50 milliseconds

//     // Clean up the interval on component unmount
//     return () => clearInterval(interval);
//   }, [start, end, duration]);

//   // Format the number with commas (e.g., 1,000,000)
//   const formattedCount = new Intl.NumberFormat().format(count);

//   return (
//     <div className="counter">
//       <span>{formattedCount}</span>
//     </div>
//   );
// };

// const FunfactSection = () => {
//   return (
//     <section className="funfact-section-four">
//       <div className="bg bg-image" style={{
//         backgroundImage: 'linear-gradient(to right, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9)), url(https://img.freepik.com/free-vector/gradient-numerology-background_23-2150066807.jpg)'
//       }}></div>
//       <div className="auto-container">
//         <div className="row">
//           {/* Content Column */}
//           <div className="content-column col-lg-6 col-md-12 col-sm-12" data-aos="fade-right">
//             <div className="inner-column">
//               <div className="sec-title light">
//                 <span className="sub-title">Welcome to SHREE Tours & Travels</span>
//                 <h2 className="letters-slide-up text-split">We Provide Trusted Cab Services in Maharashtra</h2>
//                 <div className="text text-white">
//                   We have been providing Cab service to our customers for years, ensuring comfort, safety and affordability with every ride.
//                 </div>
//               </div>
//               <button type="submit" className="theme-btn btn-style-one dark-line-two hover-light">
//                 <a className="btn-title" href='/booking'>Book Your Cab</a>
//               </button>
//             </div>
//           </div>

//           {/* Image Column */}
//           <div className="fun-fact-column col-lg-6 col-md-12 col-sm-12" data-aos="fade-left">
//             <div className="inner-column">
//               <div className="counter-outer-box" data-aos="fade-up">
//                 <div className="line-top">
//                   {/* Counter Block */}
//                   <div className="counter-block-four">
//                     <div className="inner-box">
//                       <div className="content">
//                         <div className="counter-one">
//                           <Counter start={0} end={28000} duration={2000} />
//                         </div>
//                         <div className="counter-text">Active Reviews</div>
//                       </div>
//                     </div>
//                   </div>
//                   {/* Counter Block */}
//                   <div className="counter-block-four">
//                     <div className="inner-box">
//                       <div className="content">
//                         <div className="counter-one">
//                           <Counter start={0} end={8000} duration={1500} />
//                         </div>
//                         <div className="counter-text">Total Riders</div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="line-bottom">
//                   {/* Counter Block */}
//                   <div className="counter-block-four">
//                     <div className="inner-box">
//                       <div className="content">
//                         <div className="counter-one">
//                           <Counter start={0} end={70000} duration={2500} />
//                         </div>
//                         <div className="counter-text">Happy Customers</div>
//                       </div>
//                     </div>
//                   </div>
//                   {/* Counter Block */}
//                   <div className="counter-block-four">
//                     <div className="inner-box">
//                       <div className="content">
//                         <div className="counter-one">
//                           <Counter start={0} end={1200} duration={1000} />
//                         </div>
//                         <div className="counter-text">Expert Team</div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FunfactSection;


import React, { useState, useEffect, useRef } from 'react';
import Counter from './Counter';

const FunfactSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  const sectionRef = useRef(null);

  // Common duration (longest duration) for all counters to sync them
  const duration = 2500;

  useEffect(() => {
    // Create an IntersectionObserver instance
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          // Set visibility to true when the section is in view
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is visible
    );

    // Observe the section
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup the observer on component unmount
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className="funfact-section-four" ref={sectionRef}>
      <div
        className="bg bg-image"
        style={{
          backgroundImage:
            'linear-gradient(to right, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9)), url(https://img.freepik.com/free-vector/gradient-numerology-background_23-2150066807.jpg)',
        }}
      ></div>
      <div className="auto-container">
        <div className="row">
          {/* Content Column */}
          <div className="content-column col-lg-6 col-md-12 col-sm-12" data-aos="fade-right">
            <div className="inner-column">
              <div className="sec-title light">
                <span className="sub-title">Welcome to SHREE Tours & Travels</span>
                <h2 className="letters-slide-up text-split">We Provide Trusted Cab Services in Maharashtra</h2>
                <div className="text text-white">
                  We have been providing Cab service to our customers for years, ensuring comfort, safety, and affordability with every ride.
                </div>
              </div>
              <button type="submit" className="theme-btn btn-style-one dark-line-two hover-light">
                <a className="btn-title" href="/booking">
                  Book Your Cab
                </a>
              </button>
            </div>
          </div>

          {/* Image Column */}
          <div className="fun-fact-column col-lg-6 col-md-12 col-sm-12" data-aos="fade-left">
            <div className="inner-column">
              <div className="counter-outer-box" data-aos="fade-up">
                <div className="line-top">
                  {/* Counter Block */}
                  <div className="counter-block-four">
                    <div className="inner-box">
                      <div className="content">
                        <div className="counter-one">
                          <Counter start={0} end={28000} duration={duration} isVisible={isVisible} />
                        </div>
                        <div className="counter-text">Active Reviews</div>
                      </div>
                    </div>
                  </div>
                  {/* Counter Block */}
                  <div className="counter-block-four">
                    <div className="inner-box">
                      <div className="content">
                        <div className="counter-one">
                          <Counter start={0} end={8000} duration={duration} isVisible={isVisible} />
                        </div>
                        <div className="counter-text">Total Riders</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="line-bottom">
                  {/* Counter Block */}
                  <div className="counter-block-four">
                    <div className="inner-box">
                      <div className="content">
                        <div className="counter-one">
                          <Counter start={0} end={70000} duration={duration} isVisible={isVisible} />
                        </div>
                        <div className="counter-text">Happy Customers</div>
                      </div>
                    </div>
                  </div>
                  {/* Counter Block */}
                  <div className="counter-block-four">
                    <div className="inner-box">
                      <div className="content">
                        <div className="counter-one">
                          <Counter start={0} end={1200} duration={duration} isVisible={isVisible} />
                        </div>
                        <div className="counter-text">Expert Team</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FunfactSection;
